<template>
    <div v-if="allowed && (!floating || active)" class="d-flex align-center" :class="{ 'diagnostics-floating': floating }">
        <v-btn v-if="active" small outlined color="warning" to="/diagnostica-pagine" class="mr-2">
            <v-icon small left>mdi-record-circle-outline</v-icon>Diagnostica attiva
        </v-btn>
        <v-btn v-else icon to="/diagnostica-pagine" aria-label="Apri diagnostica pagine" title="Diagnostica pagine">
            <v-icon>mdi-timer-outline</v-icon>
        </v-btn>
    </div>
</template>
<script>
import { pageDiagnostics, canUseDiagnostics } from "../../utils/pageDiagnostics.mjs";
import { routePattern } from "../../utils/diagnosticsEvents.mjs";
export default {
    props: { floating: Boolean },
    data: () => ({ diagnostics: pageDiagnostics.state, now: Date.now(), timer: null }),
    computed: {
        allowed() { return this.$store.getters.isLoggedIn && canUseDiagnostics(this.$store.getters.userdata); },
        active() { return this.now && pageDiagnostics.active(); },
        identity() { return [this.$store.getters.token, this.$store.getters.isLoggedIn, this.$store.getters.userdata]; },
    },
    watch: {
        identity: { immediate: true, handler() { pageDiagnostics.sync(this.$store, this.$vlf); } },
        $route: { immediate: true, handler(route) { pageDiagnostics.setRoute(routePattern(route)); } },
    },
    mounted() {
        pageDiagnostics.connect({ api: this.$work, store: this.$store, persistence: this.$vlf });
        this.timer = setInterval(() => { this.now = Date.now(); }, 1000);
    },
    beforeDestroy() { clearInterval(this.timer); },
};
</script>
<style scoped>
.diagnostics-floating { position: fixed; right: 16px; bottom: 16px; z-index: 10; background: var(--v-background-base, #fff); padding: 8px; }
</style>
